import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'side-filters',
  templateUrl: './side-filters.component.html',
  styleUrls: ['./side-filters.component.scss']
})
export class SideFiltersComponent implements OnInit,AfterViewInit  {

  visibility: boolean = false;

  saveFilterDialog_visibility: boolean = false;

  filter_name: any = undefined;
  filter_controls:any[];
  error: boolean = false;
  errors: any = {};
  loadingOptions: { [key: string]: boolean } = {}; // Track loading state for each filter field
  trip_request_no: number[] = [];
  customer_id: number[] = [];
  csr_id: number[] = [];
  origin_id: number[] = [];
  destination_id: number[] = [];
  pickup_date: string[] = [];
  actual_pickup_datetime: string[] = [];
  delivery_date: string[] = [];
  actual_delivery_datetime: string[] = [];
  service_type: string[] = [];
  loading_references: string[] = [];
  invoice_references: string[] = [];
  last_assigned_trailer_no: string[] = [];
  last_completed_leg_no: string[] = [];
  driver_id: number[] = [];
  truck_id: number[] = [];
  status_name: string[] = [];
  due_at: string[] = [];


  @Input('FilterControls') set _FilterControls(value: any) {
    this.filter_controls = (value) ? value : [];
    // Filter controls are often provided after init; ensure URL-restored values are reflected.
    this.setFieldValues();
  }
  @Output() OnApplyFilter = new EventEmitter();
  @Output() clearFilter = new EventEmitter();

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: Event) {
    this.hide();
  }

  constructor(private confirmationService: ConfirmationService,private activatedRoute: ActivatedRoute) { }

  /**
   * Clears all UI-selected values in the filter dialog (without emitting events to parent).
   * Used when the URL/session filter is cleared externally (e.g., "Clear all filter" from page header).
   */
  private clearUiSelections(): void {
    // Clear parsed/applied values
    this.trip_request_no = [];
    this.customer_id = [];
    this.csr_id = [];
    this.origin_id = [];
    this.destination_id = [];
    this.pickup_date = [];
    this.actual_pickup_datetime = [];
    this.delivery_date = [];
    this.actual_delivery_datetime = [];
    this.service_type = [];
    this.loading_references = [];
    this.invoice_references = [];
    this.last_assigned_trailer_no = [];
    this.last_completed_leg_no = [];
    this.driver_id = [];
    this.truck_id = [];
    this.status_name = [];
    this.due_at = [];

    // Clear UI models bound to PrimeNG controls
    if (!this.filter_controls?.length) return;
    this.filter_controls.forEach((item: any) => {
      item.field_value = undefined;
      if (item.sub_fields && item.sub_fields.length > 0) {
        item.sub_fields.forEach((sub: any): void => {
          sub.field_value = undefined;
        });
      }
    });
  }

  ngOnInit(): void {
    this.extractFiltersFromUrl();
   }
  ngAfterViewInit(): void {
    // Apply filters to the fields once the view is initialized
    this.setFieldValues();  // Ensure that the fields get updated after the view is ready.
  }
  modifyFilterControls(value: string[], filters_data: any[]) {
    this.filter_controls = filters_data.filter(control => value.includes(control.key));
    // Initialize loading state for all filter controls
    this.filter_controls.forEach(control => {
      if (control.field_type === 'multiple' || control.field_type === 'select') {
        // Mark as loading if field_data is empty or undefined
        this.loadingOptions[control.key] = !control.field_data || control.field_data.length === 0;
      }
    });
    // Re-apply any restored values after controls change (e.g., allowed filters per page/tab).
    this.setFieldValues();
  }

  /**
   * Mark a filter field as loading or loaded
   */
  setFieldLoadingState(key: string, isLoading: boolean): void {
    this.loadingOptions[key] = isLoading;
  }

  /**
   * Check if a filter field is currently loading options
   */
  isFieldLoading(key: string): boolean {
    return this.loadingOptions[key] === true;
  }

  /**
   * Mark all filter fields as loaded (when options API completes)
   */
  markAllFieldsLoaded(): void {
    if (this.filter_controls) {
      this.filter_controls.forEach(control => {
        if (control.key) {
          this.loadingOptions[control.key] = false;
        }
      });
    }
  }
  extractFiltersFromUrl() {
    this.activatedRoute.queryParams.subscribe(params => {
      const filterStr = params['filter'];
// If filter was cleared externally (query param removed), also clear UI selections
      // so dropdowns don't keep showing stale selected items.
      if (!filterStr) {
        this.clearUiSelections();
        return;
      }

      if (filterStr) {
        // Decode the filter string to handle URL encoding
        // const decodedFilterStr = decodeURIComponent(filterStr);
        const decodedFilterStr = decodeURIComponent(filterStr).split("&")
        .map((item: any) => item.split("=").map((part: any) => part.trim()))
        .filter(([key, value]: [string, string]) => value !== undefined && value !== null && value !== "")
        .map(([key, value]: [string, string]) => `${key}=${value}`)
        .join("&");
        // Now, split the decoded string into key-value pairs using '&' as a delimiter
        const filterParams = decodedFilterStr.split('&');
         // Now, parse each filter parameter into the relevant field
        filterParams.forEach(param => {
          const [key, value] = param.split('=');

          // Parse each filter key and value accordingly
          if (key === 'customer_id') {
            this.customer_id = value.split(',').map(Number);
          } else if (key === 'csr_id') {
            this.csr_id = value.split(',').map(Number);
          } else if (key === 'origin_id') {
            this.origin_id = value.split(',').map(Number);
          } else if (key === 'destination_id') {
            this.destination_id = value.split(',').map(Number);
          } else if (key === 'pickup_date') {
            this.pickup_date = value.split(',');
          } else if (key === 'actual_pickup_datetime') {
            this.actual_pickup_datetime = value.split(',');
          } else if (key === 'delivery_date') {
            this.delivery_date = value.split(',');
          } else if (key === 'actual_delivery_datetime') {
            this.actual_delivery_datetime = value.split(',');
          }
          else if (key === 'trip_request_no') {
            this.trip_request_no = value.split(',').map(Number);
          } else if (key === 'service_type') {
            this.service_type = value.split(',');
          } else if (key === 'loading_references') {
            this.loading_references = value.split(',');
          } else if (key === 'invoice_references') {
            this.invoice_references = value.split(',');
          } else if (key === 'last_assigned_trailer_no') {
            this.last_assigned_trailer_no = value.split(',');
          }
          else if (key === 'last_completed_leg_no') {
            this.last_completed_leg_no = value.split(',');
          }
          else if (key === 'driver_id') {
            this.driver_id = value.split(',').map(Number);
          }
          else if (key === 'truck_id') {
            this.truck_id = value.split(',').map(Number);
          }
          else if (key === 'status_name') {
            this.status_name = value.split(',');
          }
          else if (key === 'due_at') {
            this.due_at = value.split(',');
          }
        });


        // After extracting the URL parameters, update the filter controls
        // this.setFieldValues();
        // Important: ensure UI model gets updated AFTER ids are parsed and controls are available.
        // setTimeout avoids lifecycle timing issues (queryParams callback vs view init).
        setTimeout(() => this.setFieldValues(), 0);
      } else {
        // If filter param is removed/cleared, reset UI values so popup reflects empty state.
        this.customer_id = [];
        this.csr_id = [];
        this.origin_id = [];
        this.destination_id = [];
        this.pickup_date = [];
        this.actual_pickup_datetime = [];
        this.delivery_date = [];
        this.actual_delivery_datetime = [];
        this.trip_request_no = [];
        this.service_type = [];
        this.loading_references = [];
        this.invoice_references = [];
        this.last_assigned_trailer_no = [];
        this.last_completed_leg_no = [];
        this.driver_id = [];
        this.truck_id = [];
        this.status_name = [];
        this.due_at = [];
        this.setFieldValues();
      }
    });
  }

  async setFilterSelectedValuesFromFilterServiceData(filter_str: string) {
    const filterParams = filter_str.split('&');
    // Empty and removed the selected values from the filter controls
    await this.filter_controls.forEach(item => {

      item.field_value = undefined;

      if(item.sub_fields && item.sub_fields.length > 0)
      {
        item.sub_fields.forEach((SubField:any) => {
          SubField.field_value = undefined;
        });
      }
    });
    // Reset the selected values
    this.customer_id = [];
    this.csr_id = [];
    this.origin_id = [];
    this.destination_id = [];
    this.pickup_date = [];
    this.actual_pickup_datetime = [];
    this.delivery_date = [];
    this.actual_delivery_datetime = [];
    this.trip_request_no = [];
    this.service_type = [];
    this.loading_references = [];
    this.invoice_references = [];
    this.last_assigned_trailer_no = [];
    this.last_completed_leg_no = [];
    this.driver_id = [];
    this.truck_id = [];
    this.status_name = [];
    this.due_at = [];
    // Now, parse each filter parameter into the relevant field
    filterParams.forEach(param => {
      const [key, value] = param.split('=');
      if (!value) return; // Skip empty values
      const decodedValue = decodeURIComponent(value);
      // Parse each filter key and value accordingly
      key === 'trip_request_no' ? this.trip_request_no = decodedValue.split(',').map(Number) : undefined;
      key === 'customer_id' ? this.customer_id = decodedValue.split(',').map(Number) : undefined;
      key === 'csr_id' ? this.csr_id = decodedValue.split(',').map(Number) : undefined;
      key === 'origin_id' ? this.origin_id = decodedValue.split(',').map(Number) : undefined;
      key === 'destination_id' ? this.destination_id = decodedValue.split(',').map(Number) : undefined;
      key === 'pickup_date' ? this.pickup_date = decodedValue.split(',') : undefined;
      key === 'actual_pickup_datetime' ? this.actual_pickup_datetime = decodedValue.split(',') : undefined;
      key === 'delivery_date' ? this.delivery_date = decodedValue.split(',') : undefined;
      key === 'actual_delivery_datetime' ? this.actual_delivery_datetime = decodedValue.split(',') : undefined;
      key === 'trip_request_no' ? this.trip_request_no = decodedValue.split(',').map(Number) : undefined;
      key === 'service_type' ? this.service_type = decodedValue.split(',') : undefined;
      key === 'loading_references' ? this.loading_references = decodedValue.split(',') : undefined;
      key === 'invoice_references' ? this.invoice_references = decodedValue.split(',') : undefined;
      key === 'last_assigned_trailer_no' ? this.last_assigned_trailer_no = decodedValue.split(',') : undefined;
      key === 'last_completed_leg_no' ? this.last_completed_leg_no = decodedValue.split(',') : undefined;
      key === 'driver_id' ? this.driver_id = decodedValue.split(',').map(Number) : undefined;
      key === 'truck_id' ? this.truck_id = decodedValue.split(',').map(Number) : undefined;
      key === 'status_name' ? this.status_name = decodedValue.split(',') : undefined;
      key === 'due_at' ? this.due_at = decodedValue.split(',') : undefined;
    });
    // After extracting the URL parameters, update the filter controls
    // Use setTimeout to ensure this runs after options are loaded
    setTimeout(() => {
      this.setFieldValues();
    }, 0);
  }

  setFieldValues() {
    if(this.filter_controls === undefined){
      return;
    }
    this.filter_controls.forEach(control => {
      // Skip setting values for dropdowns that are still loading options
      if ((control.field_type === 'multiple' || control.field_type === 'select') &&
          this.isFieldLoading(control.key) &&
          (!control.field_data || control.field_data.length === 0)) {
        return; // Don't set value yet, wait for options to load
      }
      if (control.field_label === 'Customer' && this.customer_id.length > 0) {
        control.field_value = this.customer_id;
      } else if (control.field_label === 'CSR' && this.csr_id.length > 0) {
        control.field_value = this.csr_id;
      } else if (control.field_label === 'Origin' && this.origin_id.length > 0) {
        control.field_value = this.origin_id;
      } else if (control.field_label === 'Destination' && this.destination_id.length > 0) {
        control.field_value = this.destination_id;
      } else if (control.field_label === 'Trip Request No' && this.trip_request_no.length > 0) {
        control.field_value = this.trip_request_no;
      } else if (control.field_label === 'Service Type' && this.service_type.length > 0) {
        control.field_value = this.service_type;
      } else if (control.field_label === 'Loading Reference' && this.loading_references.length > 0) {
        control.field_value = this.loading_references;
      } else if (control.field_label === 'Invoice Reference' && this.invoice_references.length > 0) {
        control.field_value = this.invoice_references;
      } else if (control.field_label === 'Last Assigned Trailer ID' && this.last_assigned_trailer_no.length > 0) {
        control.field_value = this.last_assigned_trailer_no;
      } else if (control.field_label === 'Last Completed Leg' && this.last_completed_leg_no.length > 0) {
        control.field_value = this.last_completed_leg_no;
      } else if (control.field_label === 'Driver Name' && this.driver_id.length > 0) {
        control.field_value = this.driver_id;
      } else if (control.field_label === 'Truck ID' && this.truck_id.length > 0) {
        control.field_value = this.truck_id;
      } else if (control.field_label === 'Status' && this.status_name.length > 0) {
        control.field_value = this.status_name;
      } else if (control.field_label === 'Due' && this.due_at.length > 0) {
        control.field_value = this.due_at;
      }
      else if (control.field_label === "Requested Pickup Date and Time" && this.pickup_date.length > 0) {
        // If pickup_date is an array of date strings, convert them into Date objects
        if (control.field_type === 'date') {
          control.field_value = new Date(this.pickup_date[0]);
        }
       else if (Array.isArray(this.pickup_date)) {
          control.field_value = this.pickup_date.map(dateStr => new Date(dateStr));
        } else if (typeof this.pickup_date === 'string') {
          control.field_value = new Date(this.pickup_date);
        } else {
          control.field_value = this.pickup_date;  // In case it's already a Date object
        }
      } else if (control.field_label === "Actual Pickup Date and Time" && this.actual_pickup_datetime.length > 0) {
        // If actual_pickup_date is an array of date strings, convert them into Date objects
        if (Array.isArray(this.actual_pickup_datetime)) {
          control.field_value = this.actual_pickup_datetime.map(dateStr => new Date(dateStr));
        } else if (typeof this.actual_pickup_datetime === 'string') {
          control.field_value = new Date(this.actual_pickup_datetime);
        } else {
          control.field_value = this.actual_pickup_datetime;  // In case it's already a Date object
        }
      } else if (control.field_label === "Requested Delivery Date and Time" && this.delivery_date.length > 0) {
        // If delivered_date is an array of date strings, convert them into Date objects
        if (control.field_type === 'date') {
          control.field_value = new Date(this.delivery_date[0]);
        }
        else if (Array.isArray(this.delivery_date)) {
          control.field_value = this.delivery_date.map(dateStr => new Date(dateStr));
        } else if (typeof this.delivery_date === 'string') {
          control.field_value = new Date(this.delivery_date);
        } else {
          control.field_value = this.delivery_date;  // In case it's already a Date object
        }
      } else if (control.field_label === "Actual Delivery Date and Time" && this.actual_delivery_datetime.length > 0) {
        // If actual_delivered_date is an array of date strings, convert them into Date objects
        if (Array.isArray(this.actual_delivery_datetime)) {
          control.field_value = this.actual_delivery_datetime.map(dateStr => new Date(dateStr));
        } else if (typeof this.actual_delivery_datetime === 'string') {
          control.field_value = new Date(this.actual_delivery_datetime);
        } else {
          control.field_value = this.actual_delivery_datetime;  // In case it's already a Date object
        }
      }
    });


  }

  // FilterControls: any[] = [
  //   {
  //     field_label: 'Saved Filters',
  //     field_type: 'select',
  //     placeholder: 'Select Filter',
  //     field_value: undefined,
  //     allow_delete: true,
  //     field_data: [
  //       { text: 'Test1', value: 'Test1' },
  //       { text: 'Test2', value: 'Test2' },
  //       { text: 'Test3', value: 'Test3' },
  //       { text: 'Test4', value: 'Test4' }
  //     ], sub_fields: []
  //   },
  //   {
  //     field_label: 'Order Number',
  //     field_type: 'text',
  //     placeholder: 'Enter Order Number',
  //     field_value: undefined
  //   },
  //   {
  //     field_label: 'Ship by Date Range',
  //     field_type: 'date-range',
  //     field_value: undefined,
  //     sub_fields: [
  //       { field_label: undefined, placeholder: 'From', field_value: undefined },
  //       { field_label: undefined, placeholder: 'To', field_value: undefined }
  //     ]
  //   },
  //   {
  //     field_label: 'Order Date Range',
  //     field_type: 'date-range',
  //     field_value: undefined,
  //     sub_fields: [
  //       { field_label: undefined, placeholder: 'From', field_value: undefined },
  //       { field_label: undefined, placeholder: 'To', field_value: undefined }
  //     ]
  //   },
  //   {
  //     field_label: 'PO Number',
  //     field_type: 'text',
  //     placeholder: 'Enter PO Number',
  //     field_value: undefined
  //   },
  //   {
  //     field_label: 'Ship to Code',
  //     field_type: 'text',
  //     placeholder: 'Enter Ship to Code',
  //     field_value: undefined
  //   },
  //   {
  //     field_label: 'Ship to City',
  //     field_type: 'select',
  //     placeholder: 'Select Ship to City',
  //     field_value: undefined,
  //     field_data: [
  //       { text: 'New York', value: 'New York' },
  //       { text: 'Los Angeles', value: 'Los Angeles' },
  //       { text: 'Houston', value: 'Houston' },
  //     ]
  //   },
  //   {
  //     field_label: 'Status',
  //     field_type: 'multiselect',
  //     placeholder: 'Select Status',
  //     field_value: undefined,
  //     field_data: [
  //       { text: 'New', value: 'New' },
  //       { text: 'Open', value: 'Open' },
  //       { text: 'On Hold', value: 'On Hold' },
  //       { text: 'Void', value: 'Void' },
  //       { text: 'Shipped', value: 'Shipped' },
  //     ], sub_fields: []
  //   },
  //   {field_label: 'Customer Number', field_type: 'text', placeholder: 'Enter Customer Number', field_value: undefined},
  //   {field_label: 'Sage Order Number', field_type: 'text', placeholder: 'Enter Sage Order Number', field_value: undefined, field_data: []},
  //   {field_label: 'Payment Check', field_type: 'select', placeholder: 'Select Payment Check', field_value: undefined, field_data: [
  //     { text: 'Yes', value: 'Yes' },
  //     { text: 'No', value: 'No' },
  //   ]},
  //   {field_label: 'Order Check', field_type: 'select', placeholder: 'Select Order Check', field_value: undefined, field_data: [{ text: 'Yes', value: 'Yes' },
  //   { text: 'No', value: 'No' }]
  // }
  // ];

  show() {
    // Initialize loading state for filter controls that don't have options yet
    if (this.filter_controls) {
      this.filter_controls.forEach(control => {
        if ((control.field_type === 'multiple' || control.field_type === 'select') && control.key) {
          // Mark as loading if field_data is empty or undefined
          if (!control.field_data || control.field_data.length === 0) {
            this.loadingOptions[control.key] = true;
          }
        }
      });
    }
    // Safety: ensure controls are re-bound from any already-parsed selections
    // right before opening the dialog.
    this.setFieldValues();
    this.visibility = true;

    setTimeout(() => {
      const maskElement = document.querySelector('.p-dialog-mask');
      const dialogElement = document.querySelector('.p-dialog');
      // If the click is only on the .p-dialog-mask element and not on the dialog itself, hide the dialog

      if (maskElement) {
        maskElement.addEventListener('click', (event) => {
          if (event.target === maskElement) {
            this.hide();
          }
        });
      } else {
        //console.error('p-dialog-mask element not found');
      }
    }, 100)
  }

  hide() {
    this.visibility = false;
  }

  delete_saveFilterConfirm(evnt: any, field:string, item:String) {
    evnt.stopPropagation();

    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this filter?',
      icon: 'i-warn',
      accept: () => {
        let Ind = this.filter_controls.findIndex(x => x.field_label == field);
        if(Ind !== -1){
          this.filter_controls[Ind].field_data = this.filter_controls[Ind].field_data.filter((x:any) => x.text !== item);
        }
        //Actual logic to perform a confirmation
      }
    });
  }

  onStatusSelect(e:any){
    //console.log(e);
    //console.log(this.FilterControls);

  }

  multiSelect_removeItem(item:string, field:string){
    let Ind = this.filter_controls.findIndex(x => x.field_label == field);
    if(Ind !== -1){
      this.filter_controls[Ind].field_value = this.filter_controls[Ind].field_value.filter((x:any) => x !== item);
    }
  }

  async resetFilter(){
    this.clearFilter.emit()
    await this.filter_controls.forEach(item => {

      item.field_value = undefined;

      if(item.sub_fields && item.sub_fields.length > 0)
      {
        item.sub_fields.forEach((SubField:any) => {
          SubField.field_value = undefined;
        });
      }
      this.hide()


    });

  }

  saveFilter() {
    let Ind = this.filter_controls.findIndex(x => x.field_label == "Saved Filters");

    if (Ind !== -1) {
      this.filter_controls[Ind].field_data.push({ text: this.filter_name, value: this.filter_name });
    }
    this.filter_name = "";
    this.saveFilterDialog_visibility = false;
  }

  applyFilter(){
    if(this.filter_controls.length){
      let filter_obj:any = "";
      this.filter_controls.forEach(cntrl => {
        if (cntrl.field_value !== undefined && cntrl.field_value !== '' && cntrl.field_value !== null) {
          if (
            cntrl.field_type == 'date-range' &&
            cntrl.field_value[0] &&
            cntrl.field_value[1]
          ) {
            this.error = false
            this.errors[cntrl.field_label] = false;
            filter_obj = filter_obj + `&${cntrl.key}=${cntrl.field_value}`;
          } else if (
            cntrl.field_type == 'date-range' &&
            cntrl.field_value[0] &&
            !cntrl.field_value[1]
          ) {
            this.error = true
            this.errors[cntrl.field_label] = true;
            return;
          }
          else if (cntrl.field_type == 'date' && cntrl.field_value) {
            // Handle single date
            this.error = false
            this.errors[cntrl.field_label] = false;
            filter_obj = filter_obj + `&${cntrl.key}=${cntrl.field_value}`;
          }
           else {
            this.error = false
            this.errors[cntrl.field_label] = false;
            filter_obj = filter_obj + `&${cntrl.key}=${encodeURIComponent(cntrl.field_value)}`;
          }
        }
      });
      // find any error on the errors object array
      let error = Object.values(this.errors).find((x:any) => x === true);
      if(error === false || error === undefined){
        this.OnApplyFilter.emit(filter_obj);
        this.hide();
      }
    }
   }
}
